// export const MAIN_API = "http://192.168.0.103:8000/api/v1";
export const MAIN_API = "https://api.fokusai.org.az/public/api/v1";
